var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_7387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5209 5.86747L18.5347 0.0913858C18.1874 -0.0365654 17.8035 -0.0365654 17.4562 0.0913858L1.13328 5.48362C0.456969 5.72124 0 6.361 0 7.07387C0 7.78674 0.456969 8.44477 1.13328 8.66412L7.32978 10.949L7.40289 18.4615C7.40289 18.8819 7.5674 19.2841 7.84158 19.5948C10.6565 22.6839 13.9467 24.0183 18.8271 24.0183C23.1409 24.0183 26.1934 22.6474 29.3922 19.2841C29.6847 18.9733 29.8492 18.5529 29.8492 18.1142L29.6481 10.7296L33.9254 9.21248V13.2155C33.5415 13.5628 33.5415 14.0929 33.5415 14.4768V18.0411C33.5415 18.4981 33.5415 19.8507 34.7113 19.8507C35.8812 19.8507 35.8629 18.5529 35.8629 18.0777V14.8058C35.8629 14.2026 35.8629 13.5628 35.607 13.2521L35.5704 8.75551L36.3747 8.40822C36.9414 8.22543 37.4166 8.06092 37.508 7.32977C37.5628 6.85452 37.4532 6.19649 36.5209 5.88575V5.86747ZM18.6626 21.5324C15.0069 21.5324 11.9177 20.3808 9.70602 18.2056L9.74257 11.8263L17.4928 14.2757C17.8401 14.4036 18.2422 14.3854 18.5895 14.2757L27.345 11.4242L27.4547 18.0411C25.0967 20.3077 21.9893 21.5506 18.6992 21.5506L18.6626 21.5324ZM18.0228 12.3747L2.59558 6.85452L18.0228 1.59024L34.4189 6.94592L18.0411 12.3747H18.0228Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_7387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5263,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.42bc18dbc7231ae38bd16de620c4ff16.svg";
export { ForwardRef as ReactComponent };